import { Component, Host, h, Prop } from '@stencil/core';
import state from '@ugc-store';
import { defaultReviewPending, IReviewPending, ReviewImageType } from '@ugc-components/ugc-pdp-review/interface';
import { FontType } from '@ugc-utils/utils';

@Component({
  tag: 'ugc-review-item-pending',
  shadow: false,
})
export class UgcReviewItemPending {
  @Prop({ mutable: true }) reviewItem: IReviewPending = defaultReviewPending;
  render() {
    const {
      reviewStaticLanguage: { IDS_MSG_SHOW_MORE = '', IDS_MSG_SHOW_LESS = '' } = {},
      isDesktop: isLargeType,
    } = state;
    const {
      ratingValue,
      reviewTitle,
      reviewText,
      postedDateLocalized,
      verifiedPurchase,
      hasRewarded,
    } = this.reviewItem;
    const fontType = isLargeType ? FontType.large : FontType.small;
    return (
      <Host class="my-16">
        <div class="mb-8 flex-row-between-center flex-wrap">
          <div class={`${isLargeType ? 'flex-row-start-center flex-wrap gap-8' : 'flex-col-start-start gap-4'}`}>
            <ugc-star withTips={false} disabled={true} size={isLargeType ? 24 : 16} realValue={ratingValue} />
            <ugc-review-title reviewTitle={reviewTitle} shareUrl={''} fontType={fontType} />
          </div>
          <ugc-review-postdate postedDateLocalized={postedDateLocalized} fontType={fontType} />
        </div>
        <ugc-review-labels verifiedPurchase={verifiedPurchase} hasRewarded={hasRewarded} fontType={fontType} />
        <div class="my-16">
          <ugc-ellipsis-text
            line={isLargeType ? 3 : 6}
            text={reviewText}
            readMore={IDS_MSG_SHOW_MORE}
            readLess={IDS_MSG_SHOW_LESS}
            contentStyle={!isLargeType && { fontSize: '14px' }}
            buttonStyle={!isLargeType && { fontSize: '12px' }}
            iconSize={isLargeType ? '24' : '15'}
          />
        </div>
        <ugc-review-content-images data={this.reviewItem} type={ReviewImageType.InPendingReview} />
      </Host>
    );
  }
}
